export const getProductVariableContext = ({ uid }, pricePrimaries) => {
  const variableContext = [
    {
      model: "product",
      type: "dynamic",
      uid
    }
  ];

  const priceContext = pricePrimaries.reduce((memo, { product, price }) => {
    const match = product === uid;
    if (match) {
      memo.push({
        model: "price",
        type: "dynamic",
        uid: price
      });
    }
    return memo;
  }, []);

  return variableContext.concat(priceContext);
};

export const getVariablesFromContext = (variables = [], context = []) => {
  return variables.filter(({ model, uid, type }) => {
    return context.find(
      (ctx) => ctx.model === model && ctx.uid === uid && ctx.type === type
    );
  });
};
